import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Icon` (P0-9 deliverable 8): the only import of an icon library in the
 * workspace. Chrome icons are Phosphor, regular weight when inactive and fill
 * when active. Type glyphs are not icons: they are `TypeGlyph`.
 */
// One module per icon, so only these icons are bundled.
import { ArrowLeftIcon as ArrowLeft } from '@phosphor-icons/react/ArrowLeft';
import { ArrowRightIcon as ArrowRight } from '@phosphor-icons/react/ArrowRight';
import { ArrowSquareOutIcon as ArrowSquareOut } from '@phosphor-icons/react/ArrowSquareOut';
import { ArrowsClockwiseIcon as ArrowsClockwise } from '@phosphor-icons/react/ArrowsClockwise';
import { ArrowsDownUpIcon as ArrowsDownUp } from '@phosphor-icons/react/ArrowsDownUp';
import { ArrowUUpLeftIcon as ArrowUUpLeft } from '@phosphor-icons/react/ArrowUUpLeft';
import { BookOpenIcon as BookOpen } from '@phosphor-icons/react/BookOpen';
import { CalendarBlankIcon as CalendarBlank } from '@phosphor-icons/react/CalendarBlank';
import { CaretDownIcon as CaretDown } from '@phosphor-icons/react/CaretDown';
import { CaretLeftIcon as CaretLeft } from '@phosphor-icons/react/CaretLeft';
import { CaretRightIcon as CaretRight } from '@phosphor-icons/react/CaretRight';
import { CaretUpIcon as CaretUp } from '@phosphor-icons/react/CaretUp';
import { ChatCircleTextIcon as ChatCircleText } from '@phosphor-icons/react/ChatCircleText';
import { CheckIcon as Check } from '@phosphor-icons/react/Check';
import { CheckCircleIcon as CheckCircle } from '@phosphor-icons/react/CheckCircle';
import { CircleIcon as Circle } from '@phosphor-icons/react/Circle';
import { CircleDashedIcon as CircleDashed } from '@phosphor-icons/react/CircleDashed';
import { CircleHalfIcon as CircleHalf } from '@phosphor-icons/react/CircleHalf';
import { ClockIcon as Clock } from '@phosphor-icons/react/Clock';
import { ColumnsIcon as Columns } from '@phosphor-icons/react/Columns';
import { CompassIcon as Compass } from '@phosphor-icons/react/Compass';
import { DotsSixVerticalIcon as DotsSixVertical } from '@phosphor-icons/react/DotsSixVertical';
import { DotsThreeIcon as DotsThree } from '@phosphor-icons/react/DotsThree';
import { EyeIcon as Eye } from '@phosphor-icons/react/Eye';
import { EyeSlashIcon as EyeSlash } from '@phosphor-icons/react/EyeSlash';
import { FeatherIcon as Feather } from '@phosphor-icons/react/Feather';
import { FileTextIcon as FileText } from '@phosphor-icons/react/FileText';
import { FlagBannerIcon as FlagBanner } from '@phosphor-icons/react/FlagBanner';
import { FunnelIcon as Funnel } from '@phosphor-icons/react/Funnel';
import { GitBranchIcon as GitBranch } from '@phosphor-icons/react/GitBranch';
import { HourglassIcon as Hourglass } from '@phosphor-icons/react/Hourglass';
import { ImageIcon as Image } from '@phosphor-icons/react/Image';
import { InfoIcon as Info } from '@phosphor-icons/react/Info';
import { KeyboardIcon as Keyboard } from '@phosphor-icons/react/Keyboard';
import { LinkIcon as Link } from '@phosphor-icons/react/Link';
import { LinkBreakIcon as LinkBreak } from '@phosphor-icons/react/LinkBreak';
import { LockIcon as Lock } from '@phosphor-icons/react/Lock';
import { MagnifyingGlassIcon as MagnifyingGlass } from '@phosphor-icons/react/MagnifyingGlass';
import { MicrophoneIcon as Microphone } from '@phosphor-icons/react/Microphone';
import { MoonIcon as Moon } from '@phosphor-icons/react/Moon';
import { NoteIcon as Note } from '@phosphor-icons/react/Note';
import { PencilSimpleIcon as PencilSimple } from '@phosphor-icons/react/PencilSimple';
import { PlayIcon as Play } from '@phosphor-icons/react/Play';
import { PlusIcon as Plus } from '@phosphor-icons/react/Plus';
import { PushPinIcon as PushPin } from '@phosphor-icons/react/PushPin';
import { QuestionIcon as Question } from '@phosphor-icons/react/Question';
import { QuotesIcon as Quotes } from '@phosphor-icons/react/Quotes';
import { ScrollIcon as Scroll } from '@phosphor-icons/react/Scroll';
import { SealCheckIcon as SealCheck } from '@phosphor-icons/react/SealCheck';
import { SealQuestionIcon as SealQuestion } from '@phosphor-icons/react/SealQuestion';
import { SidebarSimpleIcon as SidebarSimple } from '@phosphor-icons/react/SidebarSimple';
import { SkipForwardIcon as SkipForward } from '@phosphor-icons/react/SkipForward';
import { SortAscendingIcon as SortAscending } from '@phosphor-icons/react/SortAscending';
import { SortDescendingIcon as SortDescending } from '@phosphor-icons/react/SortDescending';
import { SparkleIcon as Sparkle } from '@phosphor-icons/react/Sparkle';
import { SpeakerHighIcon as SpeakerHigh } from '@phosphor-icons/react/SpeakerHigh';
import { StackIcon as Stack } from '@phosphor-icons/react/Stack';
import { TableIcon as Table } from '@phosphor-icons/react/Table';
import { TrayIcon as Tray } from '@phosphor-icons/react/Tray';
import { UploadSimpleIcon as UploadSimple } from '@phosphor-icons/react/UploadSimple';
import { WarningIcon as Warning } from '@phosphor-icons/react/Warning';
import { WarningCircleIcon as WarningCircle } from '@phosphor-icons/react/WarningCircle';
import { XIcon as X } from '@phosphor-icons/react/X';
import { XCircleIcon as XCircle } from '@phosphor-icons/react/XCircle';
const ICONS = {
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'open-page': ArrowSquareOut,
    retry: ArrowsClockwise,
    sort: ArrowsDownUp,
    undo: ArrowUUpLeft,
    book: BookOpen,
    calendar: CalendarBlank,
    'caret-down': CaretDown,
    'caret-left': CaretLeft,
    'caret-right': CaretRight,
    'caret-up': CaretUp,
    dialogue: ChatCircleText,
    check: Check,
    'check-circle': CheckCircle,
    circle: Circle,
    'circle-dashed': CircleDashed,
    'circle-half': CircleHalf,
    clock: Clock,
    split: Columns,
    compass: Compass,
    handle: DotsSixVertical,
    more: DotsThree,
    eye: Eye,
    'eye-off': EyeSlash,
    quill: Feather,
    document: FileText,
    flag: FlagBanner,
    filter: Funnel,
    branch: GitBranch,
    hourglass: Hourglass,
    image: Image,
    info: Info,
    keyboard: Keyboard,
    link: Link,
    'link-broken': LinkBreak,
    lock: Lock,
    search: MagnifyingGlass,
    microphone: Microphone,
    moon: Moon,
    note: Note,
    pencil: PencilSimple,
    play: Play,
    plus: Plus,
    pin: PushPin,
    question: Question,
    quote: Quotes,
    scroll: Scroll,
    'seal-check': SealCheck,
    'seal-question': SealQuestion,
    sidebar: SidebarSimple,
    skip: SkipForward,
    'sort-ascending': SortAscending,
    'sort-descending': SortDescending,
    sparkle: Sparkle,
    voice: SpeakerHigh,
    stack: Stack,
    table: Table,
    inbox: Tray,
    upload: UploadSimple,
    warning: Warning,
    'warning-circle': WarningCircle,
    x: X,
    'x-circle': XCircle,
};
export const ICON_NAMES = Object.keys(ICONS);
export function Icon({ name, weight = 'regular', size = 16, label, className }) {
    const Component = ICONS[name];
    return (_jsx(Component, { size: size, weight: weight, className: ['cx-icon', className].filter(Boolean).join(' '), "data-icon": name, focusable: "false", ...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true }) }));
}
//# sourceMappingURL=icon.js.map